import { render, staticRenderFns } from "./QuizIndexOldd.vue?vue&type=template&id=7e6956fa&"
import script from "./QuizIndexOldd.vue?vue&type=script&lang=js&"
export * from "./QuizIndexOldd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports